// Indisponibilités des chauffeurs (transport, lot T5b) : textes à l'écran, mêmes règles que le serveur
// (backend/metier.py : unavailability_text). Le chauffeur ne reçoit jamais le motif (le serveur le retire).
import { dayIn } from "@/lib/ride";

const ddmm = (iso, tz) => new Intl.DateTimeFormat("fr-FR", { timeZone: tz, day: "2-digit", month: "2-digit" }).format(new Date(iso));
const hhmm = (iso, tz) => new Intl.DateTimeFormat("fr-FR", { timeZone: tz, hour: "2-digit", minute: "2-digit" }).format(new Date(iso));
const jour = (day) => `${day.slice(8, 10)}/${day.slice(5, 7)}`; // AAAA-MM-JJ → JJ/MM
const moins = (iso, ms) => new Date(new Date(iso).getTime() - ms).toISOString();

// Premier et dernier jour touchés (heure des Réglages). Journée(s) entière(s) : la fin est le minuit qui suit le
// dernier jour ; créneau : un créneau qui finit à minuit pile ne touche pas le lendemain.
export const firstDay = (u, tz) => dayIn(u.start, tz);
export const lastDay = (u, tz) => dayIn(moins(u.end, u.all_day ? 12 * 3600000 : 1000), tz);

// Texte complet : « le 28/10 (toute la journée) », « du 28/10 au 30/10 (journées entières) »,
// « du 28/10 à 14:00 au 28/10 à 18:00 ».
export function unavText(u, tz) {
  if (u.all_day) {
    const premier = firstDay(u, tz);
    const dernier = lastDay(u, tz);
    return premier === dernier ? `le ${jour(premier)} (toute la journée)` : `du ${jour(premier)} au ${jour(dernier)} (journées entières)`;
  }
  return `du ${ddmm(u.start, tz)} à ${hhmm(u.start, tz)} au ${ddmm(u.end, tz)} à ${hhmm(u.end, tz)}`;
}

// Texte court, vu depuis le jour affiché `day` : « 14:00 → 18:00 », « toute la journée », « jusqu'au 30/10 »,
// « jusqu'à 02:00 » (commencée la veille), « à partir de 22:00 » (continue le lendemain).
export function unavShort(u, tz, day) {
  const avant = firstDay(u, tz) < day;
  const apres = lastDay(u, tz) > day;
  if (u.all_day || (avant && apres)) return apres ? `jusqu'au ${jour(lastDay(u, tz))}` : "toute la journée";
  if (!avant && !apres) return `${hhmm(u.start, tz)} → ${hhmm(u.end, tz)}`;
  return avant ? `jusqu'à ${hhmm(u.end, tz)}` : `à partir de ${hhmm(u.start, tz)}`;
}

// Fin d'une indisponibilité en cours, vue d'aujourd'hui : « jusqu'à 18:00 », « jusqu'à minuit »,
// « jusqu'au 30/10 » (fin à minuit : journées entières), « jusqu'au 30/10 à 18:00 ».
export function untilText(end, tz, today) {
  if (hhmm(end, tz) === "00:00") {
    const dernier = dayIn(moins(end, 1000), tz);
    return dernier === today ? "jusqu'à minuit" : `jusqu'au ${jour(dernier)}`;
  }
  return dayIn(end, tz) === today ? `jusqu'à ${hhmm(end, tz)}` : `jusqu'au ${ddmm(end, tz)} à ${hhmm(end, tz)}`;
}
